<template>
    <notification-item
        :title="title"
        :created="data.created"
        :author="data.payload.teamName"
        avatar="/img/myteam/Team-Crest.png"
        :link="{ name: 'teamDetail', params: { id: data.payload.teamId } }"
    >
        <p v-if="isMy">Byl jste vyhozen z týmu <span class="semibold semibold--textgreen"><router-link :to="{ name: 'teamDetail', params: { id: data.payload.teamId } }">{{ data.payload.teamName }}</router-link></span>.</p>
        <p v-else>Hráč <span class="semibold semibold--textgreen"><router-link :to="{ name: 'userDetail', params: { id: data.payload.userId } }">{{ data.payload.userName }}</router-link></span> byl vyhozen z týmu.</p>
    </notification-item>
</template>

<script>
    import { mapState } from 'vuex'
    import NotificationMixin from '../NotificationMixin';

    export default {
        name: 'MemberFired',
        mixins: [NotificationMixin],
        computed: {
            ...mapState({
                user: state => state.user.user,
            }),
            isMy () {
                return this.user.id === this.data.payload.memberId;
            },
            title () {
                return this.isMy ? 'Byl jste vyhozen' : 'Hráč byl vyhozen';
            },
        },
    }
</script>
